import { render } from "./UseResourceBonusCrop.vue?vue&type=template&id=d6845b9a"
import script from "./UseResourceBonusCrop.vue?vue&type=script&lang=js"
export * from "./UseResourceBonusCrop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/windowOverlay/UseResourceBonusCrop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6845b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6845b9a', __exports__)) {
    api.reload('d6845b9a', __exports__)
  }
  
  module.hot.accept("./UseResourceBonusCrop.vue?vue&type=template&id=d6845b9a", () => {
    api.rerender('d6845b9a', render)
  })

}


export default __exports__